import { HashRouter as Router } from "react-router-dom";
import Footer from "./Component/Footer";
import Navbar from "./Component/Navbar";
import Content from "./Component/Content";
import AppointmentProvider from "./Component/AppointmentContext";
import { UserContext } from "./Component/UserContext.js";
import MobileBookButton from "./Component/MobileButton.js";

function App() {
  return (
    <UserContext>
      <AppointmentProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Content />
            <Footer />
          </div>
          <MobileBookButton />
        </Router>
      </AppointmentProvider>
    </UserContext>
  );
}

export default App;
